<mat-form-field subscriptSizing="dynamic">
  <mat-label>{{ 'COMMON.TIMEZONE' | translate }}</mat-label>
  <mat-select [disabled]="disabled" [(value)]="currentTimezone" (selectionChange)="onChangeTimezone($event.value)">
    @for (tz of timezones; track tz) {
      <mat-option [value]="tz">{{ tz }}</mat-option>
    }
  </mat-select>
</mat-form-field>
